import { requester } from '../utils';

export const fetchAllIntroducedCafes = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/introduced-cafe?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch introduced cafes error', err);
        reject(err);
      });
  });
};


export const fetchIntroducedCafeDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/introduced-cafe/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch introduced cafes error', err);
        reject(err);
      });
  });
};


export const changeCafeStatus = (status, rejectReason, cafeId) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/introduced-cafe/status`,
        method: 'PUT',
        data: {
          status,
          reasonRejected: rejectReason,
          id: cafeId
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch introduced cafes error', err);
        reject(err);
      });
  });
};